import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import PublicLayout from "@/pages/PublicLayout";
import Home from "@/pages/Home";
import Cucina from "@/pages/Cucina";
import MenuPage from "@/pages/MenuPage";
import Borgo from "@/pages/Borgo";
import Galleria from "@/pages/Galleria";
import Contatti from "@/pages/Contatti";
import Prenota from "@/pages/Prenota";
import Conferma from "@/pages/Conferma";
import CartaQR from "@/pages/CartaQR";
import LegalPage from "@/pages/LegalPage";
import ProgettiFuturi from "@/pages/ProgettiFuturi";
import Diario from "@/pages/Diario";
import Articolo from "@/pages/Articolo";
import DiarioCategoria from "@/pages/DiarioCategoria";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminArticlePreview from "@/pages/admin/AdminArticlePreview";
import AdminIdeas from "@/pages/admin/AdminIdeas";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminToday from "@/pages/admin/AdminToday";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminReservations from "@/pages/admin/AdminReservations";
import AdminServices from "@/pages/admin/AdminServices";
import AdminSpecialDates from "@/pages/admin/AdminSpecialDates";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminContent from "@/pages/admin/AdminContent";

function NotFound() {
  return (
    <div className="pt-40 pb-32 bg-cream">
      <div className="container-ed max-w-xl">
        <p className="eyebrow text-sage">404</p>
        <h1 className="mt-4 font-serif text-4xl text-wood">Questa pagina non esiste</h1>
        <a href="/" className="mt-8 inline-flex px-8 py-4 bg-sage text-cream text-[0.7rem] uppercase tracking-[0.22em]">
          Torna alla home
        </a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <AdminAuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/la-cucina" element={<Cucina />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/il-borgo" element={<Borgo />} />
              <Route path="/progetti-futuri" element={<ProgettiFuturi />} />
              <Route path="/il-progetto" element={<Navigate to="/progetti-futuri" replace />} />
              <Route path="/diario-dal-borgo" element={<Diario />} />
              <Route path="/diario-dal-borgo/idee-per-il-borgo" element={<DiarioCategoria />} />
              <Route path="/diario-dal-borgo/:slug" element={<Articolo />} />
              <Route path="/galleria" element={<Galleria />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/prenota" element={<Prenota />} />
              <Route path="/prenotazione-confermata" element={<Conferma />} />
              <Route path="/privacy" element={<LegalPage kind="privacy" />} />
              <Route path="/cookie-policy" element={<LegalPage kind="cookie" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/carta/:token" element={<CartaQR />} />
            <Route path="/admin/login" element={<AdminLogin />} />            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminToday />} />
              <Route path="calendario" element={<AdminCalendar />} />
              <Route path="prenotazioni" element={<AdminReservations />} />
              <Route path="servizi" element={<AdminServices />} />
              <Route path="date-speciali" element={<AdminSpecialDates />} />
              <Route path="menu" element={<AdminMenu />} />
              <Route path="galleria" element={<AdminGallery />} />
              <Route path="diario" element={<AdminArticles />} />
              <Route path="diario/idee" element={<AdminIdeas />} />
              <Route path="diario/anteprima/:id" element={<AdminArticlePreview />} />
              <Route path="contenuti" element={<AdminContent />} />
            </Route>
          </Routes>
          <Toaster position="top-center" />
        </AdminAuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}
